module.exports = __webpack_public_path__ + "build/desktop/a/img/food.487691c6db26b875659638e18d88cbf0.png";